// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-128{width:32rem}.h-96{height:24rem}.t-4{top:1rem}.-r-64{right:-16rem}.emoji-invoker{transition:all .2s}.emoji-invoker:hover{transform:scale(1.1)}.emojis:after{content:\"\";flex:auto}.editr--content[contenteditable=true]:empty:before{color:inherit}", ""]);
// Exports
module.exports = exports;
